/* eslint-disable quotes */
export default [
  {
    Name: 'Afghanistan',
    Alpha2: 'AF',
    Alpha3: 'AFG',
    Numeric: 4,
    Iso3166_2: 'ISO 3166-2:AF',
    LocalizedName: 'Afghanistan',
  },
  {
    Name: 'Åland Islands',
    Alpha2: 'AX',
    Alpha3: 'ALA',
    Numeric: 248,
    Iso3166_2: 'ISO 3166-2:AX',
    LocalizedName: 'Åland Islands',
  },
  {
    Name: 'Albania',
    Alpha2: 'AL',
    Alpha3: 'ALB',
    Numeric: 8,
    Iso3166_2: 'ISO 3166-2:AL',
    LocalizedName: 'Albania',
  },
  {
    Name: 'Algeria',
    Alpha2: 'DZ',
    Alpha3: 'DZA',
    Numeric: 12,
    Iso3166_2: 'ISO 3166-2:DZ',
    LocalizedName: 'Algeria',
  },
  {
    Name: 'American Samoa',
    Alpha2: 'AS',
    Alpha3: 'ASM',
    Numeric: 16,
    Iso3166_2: 'ISO 3166-2:AS',
    LocalizedName: 'American Samoa',
  },
  {
    Name: 'Andorra',
    Alpha2: 'AD',
    Alpha3: 'AND',
    Numeric: 20,
    Iso3166_2: 'ISO 3166-2:AD',
    LocalizedName: 'Andorra',
  },
  {
    Name: 'Angola',
    Alpha2: 'AO',
    Alpha3: 'AGO',
    Numeric: 24,
    Iso3166_2: 'ISO 3166-2:AO',
    LocalizedName: 'Angola',
  },
  {
    Name: 'Anguilla',
    Alpha2: 'AI',
    Alpha3: 'AIA',
    Numeric: 660,
    Iso3166_2: 'ISO 3166-2:AI',
    LocalizedName: 'Anguilla',
  },
  {
    Name: 'Antarctica',
    Alpha2: 'AQ',
    Alpha3: 'ATA',
    Numeric: 10,
    Iso3166_2: 'ISO 3166-2:AQ',
    LocalizedName: 'Antarctica',
  },
  {
    Name: 'Antigua and Barbuda',
    Alpha2: 'AG',
    Alpha3: 'ATG',
    Numeric: 28,
    Iso3166_2: 'ISO 3166-2:AG',
    LocalizedName: 'Antigua & Barbuda',
  },
  {
    Name: 'Argentina',
    Alpha2: 'AR',
    Alpha3: 'ARG',
    Numeric: 32,
    Iso3166_2: 'ISO 3166-2:AR',
    LocalizedName: 'Argentina',
  },
  {
    Name: 'Armenia',
    Alpha2: 'AM',
    Alpha3: 'ARM',
    Numeric: 51,
    Iso3166_2: 'ISO 3166-2:AM',
    LocalizedName: 'Armenia',
  },
  {
    Name: 'Aruba',
    Alpha2: 'AW',
    Alpha3: 'ABW',
    Numeric: 533,
    Iso3166_2: 'ISO 3166-2:AW',
    LocalizedName: 'Aruba',
  },
  {
    Name: 'Australia',
    Alpha2: 'AU',
    Alpha3: 'AUS',
    Numeric: 36,
    Iso3166_2: 'ISO 3166-2:AU',
    LocalizedName: 'Australia',
  },
  {
    Name: 'Austria',
    Alpha2: 'AT',
    Alpha3: 'AUT',
    Numeric: 40,
    Iso3166_2: 'ISO 3166-2:AT',
    LocalizedName: 'Austria',
  },
  {
    Name: 'Azerbaijan',
    Alpha2: 'AZ',
    Alpha3: 'AZE',
    Numeric: 31,
    Iso3166_2: 'ISO 3166-2:AZ',
    LocalizedName: 'Azerbaijan',
  },
  {
    Name: 'Bahamas (the)',
    Alpha2: 'BS',
    Alpha3: 'BHS',
    Numeric: 44,
    Iso3166_2: 'ISO 3166-2:BS',
    LocalizedName: 'Bahamas',
  },
  {
    Name: 'Bahrain',
    Alpha2: 'BH',
    Alpha3: 'BHR',
    Numeric: 48,
    Iso3166_2: 'ISO 3166-2:BH',
    LocalizedName: 'Bahrain',
  },
  {
    Name: 'Bangladesh',
    Alpha2: 'BD',
    Alpha3: 'BGD',
    Numeric: 50,
    Iso3166_2: 'ISO 3166-2:BD',
    LocalizedName: 'Bangladesh',
  },
  {
    Name: 'Barbados',
    Alpha2: 'BB',
    Alpha3: 'BRB',
    Numeric: 52,
    Iso3166_2: 'ISO 3166-2:BB',
    LocalizedName: 'Barbados',
  },
  {
    Name: 'Belarus',
    Alpha2: 'BY',
    Alpha3: 'BLR',
    Numeric: 112,
    Iso3166_2: 'ISO 3166-2:BY',
    LocalizedName: 'Belarus',
  },
  {
    Name: 'Belgium',
    Alpha2: 'BE',
    Alpha3: 'BEL',
    Numeric: 56,
    Iso3166_2: 'ISO 3166-2:BE',
    LocalizedName: 'Belgium',
  },
  {
    Name: 'Belize',
    Alpha2: 'BZ',
    Alpha3: 'BLZ',
    Numeric: 84,
    Iso3166_2: 'ISO 3166-2:BZ',
    LocalizedName: 'Belize',
  },
  {
    Name: 'Benin',
    Alpha2: 'BJ',
    Alpha3: 'BEN',
    Numeric: 204,
    Iso3166_2: 'ISO 3166-2:BJ',
    LocalizedName: 'Benin',
  },
  {
    Name: 'Bermuda',
    Alpha2: 'BM',
    Alpha3: 'BMU',
    Numeric: 60,
    Iso3166_2: 'ISO 3166-2:BM',
    LocalizedName: 'Bermuda',
  },
  {
    Name: 'Bhutan',
    Alpha2: 'BT',
    Alpha3: 'BTN',
    Numeric: 64,
    Iso3166_2: 'ISO 3166-2:BT',
    LocalizedName: 'Bhutan',
  },
  {
    Name: 'Bolivia (Plurinational State of)',
    Alpha2: 'BO',
    Alpha3: 'BOL',
    Numeric: 68,
    Iso3166_2: 'ISO 3166-2:BO',
    LocalizedName: 'Bolivia',
  },
  {
    Name: 'Bonaire, Sint Eustatius and Saba',
    Alpha2: 'BQ',
    Alpha3: 'BES',
    Numeric: 535,
    Iso3166_2: 'ISO 3166-2:BQ',
    LocalizedName: 'Caribbean Netherlands',
  },
  {
    Name: 'Bosnia and Herzegovina',
    Alpha2: 'BA',
    Alpha3: 'BIH',
    Numeric: 70,
    Iso3166_2: 'ISO 3166-2:BA',
    LocalizedName: 'Bosnia & Herzegovina',
  },
  {
    Name: 'Botswana',
    Alpha2: 'BW',
    Alpha3: 'BWA',
    Numeric: 72,
    Iso3166_2: 'ISO 3166-2:BW',
    LocalizedName: 'Botswana',
  },
  {
    Name: 'Bouvet Island',
    Alpha2: 'BV',
    Alpha3: 'BVT',
    Numeric: 74,
    Iso3166_2: 'ISO 3166-2:BV',
    LocalizedName: 'Bouvet Island',
  },
  {
    Name: 'Brazil',
    Alpha2: 'BR',
    Alpha3: 'BRA',
    Numeric: 76,
    Iso3166_2: 'ISO 3166-2:BR',
    LocalizedName: 'Brazil',
  },
  {
    Name: 'British Indian Ocean Territory (the)',
    Alpha2: 'IO',
    Alpha3: 'IOT',
    Numeric: 86,
    Iso3166_2: 'ISO 3166-2:IO',
    LocalizedName: 'British Indian Ocean Territory',
  },
  {
    Name: 'Brunei Darussalam',
    Alpha2: 'BN',
    Alpha3: 'BRN',
    Numeric: 96,
    Iso3166_2: 'ISO 3166-2:BN',
    LocalizedName: 'Brunei',
  },
  {
    Name: 'Bulgaria',
    Alpha2: 'BG',
    Alpha3: 'BGR',
    Numeric: 100,
    Iso3166_2: 'ISO 3166-2:BG',
    LocalizedName: 'Bulgaria',
  },
  {
    Name: 'Burkina Faso',
    Alpha2: 'BF',
    Alpha3: 'BFA',
    Numeric: 854,
    Iso3166_2: 'ISO 3166-2:BF',
    LocalizedName: 'Burkina Faso',
  },
  {
    Name: 'Burundi',
    Alpha2: 'BI',
    Alpha3: 'BDI',
    Numeric: 108,
    Iso3166_2: 'ISO 3166-2:BI',
    LocalizedName: 'Burundi',
  },
  {
    Name: 'Cabo Verde',
    Alpha2: 'CV',
    Alpha3: 'CPV',
    Numeric: 132,
    Iso3166_2: 'ISO 3166-2:CV',
    LocalizedName: 'Cape Verde',
  },
  {
    Name: 'Cambodia',
    Alpha2: 'KH',
    Alpha3: 'KHM',
    Numeric: 116,
    Iso3166_2: 'ISO 3166-2:KH',
    LocalizedName: 'Cambodia',
  },
  {
    Name: 'Cameroon',
    Alpha2: 'CM',
    Alpha3: 'CMR',
    Numeric: 120,
    Iso3166_2: 'ISO 3166-2:CM',
    LocalizedName: 'Cameroon',
  },
  {
    Name: 'Canada',
    Alpha2: 'CA',
    Alpha3: 'CAN',
    Numeric: 124,
    Iso3166_2: 'ISO 3166-2:CA',
    LocalizedName: 'Canada',
  },
  {
    Name: 'Cayman Islands (the)',
    Alpha2: 'KY',
    Alpha3: 'CYM',
    Numeric: 136,
    Iso3166_2: 'ISO 3166-2:KY',
    LocalizedName: 'Cayman Islands',
  },
  {
    Name: 'Central African Republic (the)',
    Alpha2: 'CF',
    Alpha3: 'CAF',
    Numeric: 140,
    Iso3166_2: 'ISO 3166-2:CF',
    LocalizedName: 'Central African Republic',
  },
  {
    Name: 'Chad',
    Alpha2: 'TD',
    Alpha3: 'TCD',
    Numeric: 148,
    Iso3166_2: 'ISO 3166-2:TD',
    LocalizedName: 'Chad',
  },
  {
    Name: 'Chile',
    Alpha2: 'CL',
    Alpha3: 'CHL',
    Numeric: 152,
    Iso3166_2: 'ISO 3166-2:CL',
    LocalizedName: 'Chile',
  },
  {
    Name: 'China',
    Alpha2: 'CN',
    Alpha3: 'CHN',
    Numeric: 156,
    Iso3166_2: 'ISO 3166-2:CN',
    LocalizedName: 'China',
  },
  {
    Name: 'Christmas Island',
    Alpha2: 'CX',
    Alpha3: 'CXR',
    Numeric: 162,
    Iso3166_2: 'ISO 3166-2:CX',
    LocalizedName: 'Christmas Island',
  },
  {
    Name: 'Cocos (Keeling) Islands (the)',
    Alpha2: 'CC',
    Alpha3: 'CCK',
    Numeric: 166,
    Iso3166_2: 'ISO 3166-2:CC',
    LocalizedName: 'Cocos (Keeling) Islands',
  },
  {
    Name: 'Colombia',
    Alpha2: 'CO',
    Alpha3: 'COL',
    Numeric: 170,
    Iso3166_2: 'ISO 3166-2:CO',
    LocalizedName: 'Colombia',
  },
  {
    Name: 'Comoros (the)',
    Alpha2: 'KM',
    Alpha3: 'COM',
    Numeric: 174,
    Iso3166_2: 'ISO 3166-2:KM',
    LocalizedName: 'Comoros',
  },
  {
    Name: 'Congo (the)',
    Alpha2: 'CG',
    Alpha3: 'COG',
    Numeric: 178,
    Iso3166_2: 'ISO 3166-2:CG',
    LocalizedName: 'Congo - Brazzaville',
  },
  {
    Name: 'Congo (the Democratic Republic of the)',
    Alpha2: 'CD',
    Alpha3: 'COD',
    Numeric: 180,
    Iso3166_2: 'ISO 3166-2:CD',
    LocalizedName: 'Congo - Kinshasa',
  },
  {
    Name: 'Cook Islands (the)',
    Alpha2: 'CK',
    Alpha3: 'COK',
    Numeric: 184,
    Iso3166_2: 'ISO 3166-2:CK',
    LocalizedName: 'Cook Islands',
  },
  {
    Name: 'Costa Rica',
    Alpha2: 'CR',
    Alpha3: 'CRI',
    Numeric: 188,
    Iso3166_2: 'ISO 3166-2:CR',
    LocalizedName: 'Costa Rica',
  },
  {
    Name: "Côte d'Ivoire",
    Alpha2: 'CI',
    Alpha3: 'CIV',
    Numeric: 384,
    Iso3166_2: 'ISO 3166-2:CI',
    LocalizedName: 'Côte d’Ivoire',
  },
  {
    Name: 'Croatia',
    Alpha2: 'HR',
    Alpha3: 'HRV',
    Numeric: 191,
    Iso3166_2: 'ISO 3166-2:HR',
    LocalizedName: 'Croatia',
  },
  {
    Name: 'Cuba',
    Alpha2: 'CU',
    Alpha3: 'CUB',
    Numeric: 192,
    Iso3166_2: 'ISO 3166-2:CU',
    LocalizedName: 'Cuba',
  },
  {
    Name: 'Curaçao',
    Alpha2: 'CW',
    Alpha3: 'CUW',
    Numeric: 531,
    Iso3166_2: 'ISO 3166-2:CW',
    LocalizedName: 'Curaçao',
  },
  {
    Name: 'Cyprus',
    Alpha2: 'CY',
    Alpha3: 'CYP',
    Numeric: 196,
    Iso3166_2: 'ISO 3166-2:CY',
    LocalizedName: 'Cyprus',
  },
  {
    Name: 'Czechia',
    Alpha2: 'CZ',
    Alpha3: 'CZE',
    Numeric: 203,
    Iso3166_2: 'ISO 3166-2:CZ',
    LocalizedName: 'Czechia',
  },
  {
    Name: 'Denmark',
    Alpha2: 'DK',
    Alpha3: 'DNK',
    Numeric: 208,
    Iso3166_2: 'ISO 3166-2:DK',
    LocalizedName: 'Denmark',
  },
  {
    Name: 'Djibouti',
    Alpha2: 'DJ',
    Alpha3: 'DJI',
    Numeric: 262,
    Iso3166_2: 'ISO 3166-2:DJ',
    LocalizedName: 'Djibouti',
  },
  {
    Name: 'Dominica',
    Alpha2: 'DM',
    Alpha3: 'DMA',
    Numeric: 212,
    Iso3166_2: 'ISO 3166-2:DM',
    LocalizedName: 'Dominica',
  },
  {
    Name: 'Dominican Republic (the)',
    Alpha2: 'DO',
    Alpha3: 'DOM',
    Numeric: 214,
    Iso3166_2: 'ISO 3166-2:DO',
    LocalizedName: 'Dominican Republic',
  },
  {
    Name: 'Ecuador',
    Alpha2: 'EC',
    Alpha3: 'ECU',
    Numeric: 218,
    Iso3166_2: 'ISO 3166-2:EC',
    LocalizedName: 'Ecuador',
  },
  {
    Name: 'Egypt',
    Alpha2: 'EG',
    Alpha3: 'EGY',
    Numeric: 818,
    Iso3166_2: 'ISO 3166-2:EG',
    LocalizedName: 'Egypt',
  },
  {
    Name: 'El Salvador',
    Alpha2: 'SV',
    Alpha3: 'SLV',
    Numeric: 222,
    Iso3166_2: 'ISO 3166-2:SV',
    LocalizedName: 'El Salvador',
  },
  {
    Name: 'Equatorial Guinea',
    Alpha2: 'GQ',
    Alpha3: 'GNQ',
    Numeric: 226,
    Iso3166_2: 'ISO 3166-2:GQ',
    LocalizedName: 'Equatorial Guinea',
  },
  {
    Name: 'Eritrea',
    Alpha2: 'ER',
    Alpha3: 'ERI',
    Numeric: 232,
    Iso3166_2: 'ISO 3166-2:ER',
    LocalizedName: 'Eritrea',
  },
  {
    Name: 'Estonia',
    Alpha2: 'EE',
    Alpha3: 'EST',
    Numeric: 233,
    Iso3166_2: 'ISO 3166-2:EE',
    LocalizedName: 'Estonia',
  },
  {
    Name: 'Ethiopia',
    Alpha2: 'ET',
    Alpha3: 'ETH',
    Numeric: 231,
    Iso3166_2: 'ISO 3166-2:ET',
    LocalizedName: 'Ethiopia',
  },
  {
    Name: 'Falkland Islands (the) [Malvinas]',
    Alpha2: 'FK',
    Alpha3: 'FLK',
    Numeric: 238,
    Iso3166_2: 'ISO 3166-2:FK',
    LocalizedName: 'Falkland Islands',
  },
  {
    Name: 'Faroe Islands (the)',
    Alpha2: 'FO',
    Alpha3: 'FRO',
    Numeric: 234,
    Iso3166_2: 'ISO 3166-2:FO',
    LocalizedName: 'Faroe Islands',
  },
  {
    Name: 'Fiji',
    Alpha2: 'FJ',
    Alpha3: 'FJI',
    Numeric: 242,
    Iso3166_2: 'ISO 3166-2:FJ',
    LocalizedName: 'Fiji',
  },
  {
    Name: 'Finland',
    Alpha2: 'FI',
    Alpha3: 'FIN',
    Numeric: 246,
    Iso3166_2: 'ISO 3166-2:FI',
    LocalizedName: 'Finland',
  },
  {
    Name: 'France',
    Alpha2: 'FR',
    Alpha3: 'FRA',
    Numeric: 250,
    Iso3166_2: 'ISO 3166-2:FR',
    LocalizedName: 'France',
  },
  {
    Name: 'French Guiana',
    Alpha2: 'GF',
    Alpha3: 'GUF',
    Numeric: 254,
    Iso3166_2: 'ISO 3166-2:GF',
    LocalizedName: 'French Guiana',
  },
  {
    Name: 'French Polynesia',
    Alpha2: 'PF',
    Alpha3: 'PYF',
    Numeric: 258,
    Iso3166_2: 'ISO 3166-2:PF',
    LocalizedName: 'French Polynesia',
  },
  {
    Name: 'French Southern Territories (the)',
    Alpha2: 'TF',
    Alpha3: 'ATF',
    Numeric: 260,
    Iso3166_2: 'ISO 3166-2:TF',
    LocalizedName: 'French Southern Territories',
  },
  {
    Name: 'Gabon',
    Alpha2: 'GA',
    Alpha3: 'GAB',
    Numeric: 266,
    Iso3166_2: 'ISO 3166-2:GA',
    LocalizedName: 'Gabon',
  },
  {
    Name: 'Gambia (the)',
    Alpha2: 'GM',
    Alpha3: 'GMB',
    Numeric: 270,
    Iso3166_2: 'ISO 3166-2:GM',
    LocalizedName: 'Gambia',
  },
  {
    Name: 'Georgia',
    Alpha2: 'GE',
    Alpha3: 'GEO',
    Numeric: 268,
    Iso3166_2: 'ISO 3166-2:GE',
    LocalizedName: 'Georgia',
  },
  {
    Name: 'Germany',
    Alpha2: 'DE',
    Alpha3: 'DEU',
    Numeric: 276,
    Iso3166_2: 'ISO 3166-2:DE',
    LocalizedName: 'Germany',
  },
  {
    Name: 'Ghana',
    Alpha2: 'GH',
    Alpha3: 'GHA',
    Numeric: 288,
    Iso3166_2: 'ISO 3166-2:GH',
    LocalizedName: 'Ghana',
  },
  {
    Name: 'Gibraltar',
    Alpha2: 'GI',
    Alpha3: 'GIB',
    Numeric: 292,
    Iso3166_2: 'ISO 3166-2:GI',
    LocalizedName: 'Gibraltar',
  },
  {
    Name: 'Greece',
    Alpha2: 'GR',
    Alpha3: 'GRC',
    Numeric: 300,
    Iso3166_2: 'ISO 3166-2:GR',
    LocalizedName: 'Greece',
  },
  {
    Name: 'Greenland',
    Alpha2: 'GL',
    Alpha3: 'GRL',
    Numeric: 304,
    Iso3166_2: 'ISO 3166-2:GL',
    LocalizedName: 'Greenland',
  },
  {
    Name: 'Grenada',
    Alpha2: 'GD',
    Alpha3: 'GRD',
    Numeric: 308,
    Iso3166_2: 'ISO 3166-2:GD',
    LocalizedName: 'Grenada',
  },
  {
    Name: 'Guadeloupe',
    Alpha2: 'GP',
    Alpha3: 'GLP',
    Numeric: 312,
    Iso3166_2: 'ISO 3166-2:GP',
    LocalizedName: 'Guadeloupe',
  },
  {
    Name: 'Guam',
    Alpha2: 'GU',
    Alpha3: 'GUM',
    Numeric: 316,
    Iso3166_2: 'ISO 3166-2:GU',
    LocalizedName: 'Guam',
  },
  {
    Name: 'Guatemala',
    Alpha2: 'GT',
    Alpha3: 'GTM',
    Numeric: 320,
    Iso3166_2: 'ISO 3166-2:GT',
    LocalizedName: 'Guatemala',
  },
  {
    Name: 'Guernsey',
    Alpha2: 'GG',
    Alpha3: 'GGY',
    Numeric: 831,
    Iso3166_2: 'ISO 3166-2:GG',
    LocalizedName: 'Guernsey',
  },
  {
    Name: 'Guinea',
    Alpha2: 'GN',
    Alpha3: 'GIN',
    Numeric: 324,
    Iso3166_2: 'ISO 3166-2:GN',
    LocalizedName: 'Guinea',
  },
  {
    Name: 'Guinea-Bissau',
    Alpha2: 'GW',
    Alpha3: 'GNB',
    Numeric: 624,
    Iso3166_2: 'ISO 3166-2:GW',
    LocalizedName: 'Guinea-Bissau',
  },
  {
    Name: 'Guyana',
    Alpha2: 'GY',
    Alpha3: 'GUY',
    Numeric: 328,
    Iso3166_2: 'ISO 3166-2:GY',
    LocalizedName: 'Guyana',
  },
  {
    Name: 'Haiti',
    Alpha2: 'HT',
    Alpha3: 'HTI',
    Numeric: 332,
    Iso3166_2: 'ISO 3166-2:HT',
    LocalizedName: 'Haiti',
  },
  {
    Name: 'Heard Island and McDonald Islands',
    Alpha2: 'HM',
    Alpha3: 'HMD',
    Numeric: 334,
    Iso3166_2: 'ISO 3166-2:HM',
    LocalizedName: 'Heard & McDonald Islands',
  },
  {
    Name: 'Holy See (the)',
    Alpha2: 'VA',
    Alpha3: 'VAT',
    Numeric: 336,
    Iso3166_2: 'ISO 3166-2:VA',
    LocalizedName: 'Vatican City',
  },
  {
    Name: 'Honduras',
    Alpha2: 'HN',
    Alpha3: 'HND',
    Numeric: 340,
    Iso3166_2: 'ISO 3166-2:HN',
    LocalizedName: 'Honduras',
  },
  {
    Name: 'Hong Kong',
    Alpha2: 'HK',
    Alpha3: 'HKG',
    Numeric: 344,
    Iso3166_2: 'ISO 3166-2:HK',
    LocalizedName: 'Hong Kong SAR China',
  },
  {
    Name: 'Hungary',
    Alpha2: 'HU',
    Alpha3: 'HUN',
    Numeric: 348,
    Iso3166_2: 'ISO 3166-2:HU',
    LocalizedName: 'Hungary',
  },
  {
    Name: 'Iceland',
    Alpha2: 'IS',
    Alpha3: 'ISL',
    Numeric: 352,
    Iso3166_2: 'ISO 3166-2:IS',
    LocalizedName: 'Iceland',
  },
  {
    Name: 'India',
    Alpha2: 'IN',
    Alpha3: 'IND',
    Numeric: 356,
    Iso3166_2: 'ISO 3166-2:IN',
    LocalizedName: 'India',
  },
  {
    Name: 'Indonesia',
    Alpha2: 'ID',
    Alpha3: 'IDN',
    Numeric: 360,
    Iso3166_2: 'ISO 3166-2:ID',
    LocalizedName: 'Indonesia',
  },
  {
    Name: 'Iran (Islamic Republic of)',
    Alpha2: 'IR',
    Alpha3: 'IRN',
    Numeric: 364,
    Iso3166_2: 'ISO 3166-2:IR',
    LocalizedName: 'Iran',
  },
  {
    Name: 'Iraq',
    Alpha2: 'IQ',
    Alpha3: 'IRQ',
    Numeric: 368,
    Iso3166_2: 'ISO 3166-2:IQ',
    LocalizedName: 'Iraq',
  },
  {
    Name: 'Ireland',
    Alpha2: 'IE',
    Alpha3: 'IRL',
    Numeric: 372,
    Iso3166_2: 'ISO 3166-2:IE',
    LocalizedName: 'Ireland',
  },
  {
    Name: 'Isle of Man',
    Alpha2: 'IM',
    Alpha3: 'IMN',
    Numeric: 833,
    Iso3166_2: 'ISO 3166-2:IM',
    LocalizedName: 'Isle of Man',
  },
  {
    Name: 'Israel',
    Alpha2: 'IL',
    Alpha3: 'ISR',
    Numeric: 376,
    Iso3166_2: 'ISO 3166-2:IL',
    LocalizedName: 'Israel',
  },
  {
    Name: 'Italy',
    Alpha2: 'IT',
    Alpha3: 'ITA',
    Numeric: 380,
    Iso3166_2: 'ISO 3166-2:IT',
    LocalizedName: 'Italy',
  },
  {
    Name: 'Jamaica',
    Alpha2: 'JM',
    Alpha3: 'JAM',
    Numeric: 388,
    Iso3166_2: 'ISO 3166-2:JM',
    LocalizedName: 'Jamaica',
  },
  {
    Name: 'Japan',
    Alpha2: 'JP',
    Alpha3: 'JPN',
    Numeric: 392,
    Iso3166_2: 'ISO 3166-2:JP',
    LocalizedName: 'Japan',
  },
  {
    Name: 'Jersey',
    Alpha2: 'JE',
    Alpha3: 'JEY',
    Numeric: 832,
    Iso3166_2: 'ISO 3166-2:JE',
    LocalizedName: 'Jersey',
  },
  {
    Name: 'Jordan',
    Alpha2: 'JO',
    Alpha3: 'JOR',
    Numeric: 400,
    Iso3166_2: 'ISO 3166-2:JO',
    LocalizedName: 'Jordan',
  },
  {
    Name: 'Kazakhstan',
    Alpha2: 'KZ',
    Alpha3: 'KAZ',
    Numeric: 398,
    Iso3166_2: 'ISO 3166-2:KZ',
    LocalizedName: 'Kazakhstan',
  },
  {
    Name: 'Kenya',
    Alpha2: 'KE',
    Alpha3: 'KEN',
    Numeric: 404,
    Iso3166_2: 'ISO 3166-2:KE',
    LocalizedName: 'Kenya',
  },
  {
    Name: 'Kiribati',
    Alpha2: 'KI',
    Alpha3: 'KIR',
    Numeric: 296,
    Iso3166_2: 'ISO 3166-2:KI',
    LocalizedName: 'Kiribati',
  },
  {
    Name: "Korea (the Democratic People's Republic of)",
    Alpha2: 'KP',
    Alpha3: 'PRK',
    Numeric: 408,
    Iso3166_2: 'ISO 3166-2:KP',
    LocalizedName: 'North Korea',
  },
  {
    Name: 'Korea (the Republic of)',
    Alpha2: 'KR',
    Alpha3: 'KOR',
    Numeric: 410,
    Iso3166_2: 'ISO 3166-2:KR',
    LocalizedName: 'South Korea',
  },
  {
    Name: 'Kuwait',
    Alpha2: 'KW',
    Alpha3: 'KWT',
    Numeric: 414,
    Iso3166_2: 'ISO 3166-2:KW',
    LocalizedName: 'Kuwait',
  },
  {
    Name: 'Kyrgyzstan',
    Alpha2: 'KG',
    Alpha3: 'KGZ',
    Numeric: 417,
    Iso3166_2: 'ISO 3166-2:KG',
    LocalizedName: 'Kyrgyzstan',
  },
  {
    Name: "Lao People's Democratic Republic (the)",
    Alpha2: 'LA',
    Alpha3: 'LAO',
    Numeric: 418,
    Iso3166_2: 'ISO 3166-2:LA',
    LocalizedName: 'Laos',
  },
  {
    Name: 'Latvia',
    Alpha2: 'LV',
    Alpha3: 'LVA',
    Numeric: 428,
    Iso3166_2: 'ISO 3166-2:LV',
    LocalizedName: 'Latvia',
  },
  {
    Name: 'Lebanon',
    Alpha2: 'LB',
    Alpha3: 'LBN',
    Numeric: 422,
    Iso3166_2: 'ISO 3166-2:LB',
    LocalizedName: 'Lebanon',
  },
  {
    Name: 'Lesotho',
    Alpha2: 'LS',
    Alpha3: 'LSO',
    Numeric: 426,
    Iso3166_2: 'ISO 3166-2:LS',
    LocalizedName: 'Lesotho',
  },
  {
    Name: 'Liberia',
    Alpha2: 'LR',
    Alpha3: 'LBR',
    Numeric: 430,
    Iso3166_2: 'ISO 3166-2:LR',
    LocalizedName: 'Liberia',
  },
  {
    Name: 'Libya',
    Alpha2: 'LY',
    Alpha3: 'LBY',
    Numeric: 434,
    Iso3166_2: 'ISO 3166-2:LY',
    LocalizedName: 'Libya',
  },
  {
    Name: 'Liechtenstein',
    Alpha2: 'LI',
    Alpha3: 'LIE',
    Numeric: 438,
    Iso3166_2: 'ISO 3166-2:LI',
    LocalizedName: 'Liechtenstein',
  },
  {
    Name: 'Lithuania',
    Alpha2: 'LT',
    Alpha3: 'LTU',
    Numeric: 440,
    Iso3166_2: 'ISO 3166-2:LT',
    LocalizedName: 'Lithuania',
  },
  {
    Name: 'Luxembourg',
    Alpha2: 'LU',
    Alpha3: 'LUX',
    Numeric: 442,
    Iso3166_2: 'ISO 3166-2:LU',
    LocalizedName: 'Luxembourg',
  },
  {
    Name: 'Macao',
    Alpha2: 'MO',
    Alpha3: 'MAC',
    Numeric: 446,
    Iso3166_2: 'ISO 3166-2:MO',
    LocalizedName: 'Macao SAR China',
  },
  {
    Name: 'North Macedonia',
    Alpha2: 'MK',
    Alpha3: 'MKD',
    Numeric: 807,
    Iso3166_2: 'ISO 3166-2:MK',
    LocalizedName: 'North Macedonia',
  },
  {
    Name: 'Madagascar',
    Alpha2: 'MG',
    Alpha3: 'MDG',
    Numeric: 450,
    Iso3166_2: 'ISO 3166-2:MG',
    LocalizedName: 'Madagascar',
  },
  {
    Name: 'Malawi',
    Alpha2: 'MW',
    Alpha3: 'MWI',
    Numeric: 454,
    Iso3166_2: 'ISO 3166-2:MW',
    LocalizedName: 'Malawi',
  },
  {
    Name: 'Malaysia',
    Alpha2: 'MY',
    Alpha3: 'MYS',
    Numeric: 458,
    Iso3166_2: 'ISO 3166-2:MY',
    LocalizedName: 'Malaysia',
  },
  {
    Name: 'Maldives',
    Alpha2: 'MV',
    Alpha3: 'MDV',
    Numeric: 462,
    Iso3166_2: 'ISO 3166-2:MV',
    LocalizedName: 'Maldives',
  },
  {
    Name: 'Mali',
    Alpha2: 'ML',
    Alpha3: 'MLI',
    Numeric: 466,
    Iso3166_2: 'ISO 3166-2:ML',
    LocalizedName: 'Mali',
  },
  {
    Name: 'Malta',
    Alpha2: 'MT',
    Alpha3: 'MLT',
    Numeric: 470,
    Iso3166_2: 'ISO 3166-2:MT',
    LocalizedName: 'Malta',
  },
  {
    Name: 'Marshall Islands (the)',
    Alpha2: 'MH',
    Alpha3: 'MHL',
    Numeric: 584,
    Iso3166_2: 'ISO 3166-2:MH',
    LocalizedName: 'Marshall Islands',
  },
  {
    Name: 'Martinique',
    Alpha2: 'MQ',
    Alpha3: 'MTQ',
    Numeric: 474,
    Iso3166_2: 'ISO 3166-2:MQ',
    LocalizedName: 'Martinique',
  },
  {
    Name: 'Mauritania',
    Alpha2: 'MR',
    Alpha3: 'MRT',
    Numeric: 478,
    Iso3166_2: 'ISO 3166-2:MR',
    LocalizedName: 'Mauritania',
  },
  {
    Name: 'Mauritius',
    Alpha2: 'MU',
    Alpha3: 'MUS',
    Numeric: 480,
    Iso3166_2: 'ISO 3166-2:MU',
    LocalizedName: 'Mauritius',
  },
  {
    Name: 'Mayotte',
    Alpha2: 'YT',
    Alpha3: 'MYT',
    Numeric: 175,
    Iso3166_2: 'ISO 3166-2:YT',
    LocalizedName: 'Mayotte',
  },
  {
    Name: 'Mexico',
    Alpha2: 'MX',
    Alpha3: 'MEX',
    Numeric: 484,
    Iso3166_2: 'ISO 3166-2:MX',
    LocalizedName: 'Mexico',
  },
  {
    Name: 'Micronesia (Federated States of)',
    Alpha2: 'FM',
    Alpha3: 'FSM',
    Numeric: 583,
    Iso3166_2: 'ISO 3166-2:FM',
    LocalizedName: 'Micronesia',
  },
  {
    Name: 'Moldova (the Republic of)',
    Alpha2: 'MD',
    Alpha3: 'MDA',
    Numeric: 498,
    Iso3166_2: 'ISO 3166-2:MD',
    LocalizedName: 'Moldova',
  },
  {
    Name: 'Monaco',
    Alpha2: 'MC',
    Alpha3: 'MCO',
    Numeric: 492,
    Iso3166_2: 'ISO 3166-2:MC',
    LocalizedName: 'Monaco',
  },
  {
    Name: 'Mongolia',
    Alpha2: 'MN',
    Alpha3: 'MNG',
    Numeric: 496,
    Iso3166_2: 'ISO 3166-2:MN',
    LocalizedName: 'Mongolia',
  },
  {
    Name: 'Montenegro',
    Alpha2: 'ME',
    Alpha3: 'MNE',
    Numeric: 499,
    Iso3166_2: 'ISO 3166-2:ME',
    LocalizedName: 'Montenegro',
  },
  {
    Name: 'Montserrat',
    Alpha2: 'MS',
    Alpha3: 'MSR',
    Numeric: 500,
    Iso3166_2: 'ISO 3166-2:MS',
    LocalizedName: 'Montserrat',
  },
  {
    Name: 'Morocco',
    Alpha2: 'MA',
    Alpha3: 'MAR',
    Numeric: 504,
    Iso3166_2: 'ISO 3166-2:MA',
    LocalizedName: 'Morocco',
  },
  {
    Name: 'Mozambique',
    Alpha2: 'MZ',
    Alpha3: 'MOZ',
    Numeric: 508,
    Iso3166_2: 'ISO 3166-2:MZ',
    LocalizedName: 'Mozambique',
  },
  {
    Name: 'Myanmar',
    Alpha2: 'MM',
    Alpha3: 'MMR',
    Numeric: 104,
    Iso3166_2: 'ISO 3166-2:MM',
    LocalizedName: 'Myanmar (Burma)',
  },
  {
    Name: 'Namibia',
    Alpha2: 'NA',
    Alpha3: 'NAM',
    Numeric: 516,
    Iso3166_2: 'ISO 3166-2:NA',
    LocalizedName: 'Namibia',
  },
  {
    Name: 'Nauru',
    Alpha2: 'NR',
    Alpha3: 'NRU',
    Numeric: 520,
    Iso3166_2: 'ISO 3166-2:NR',
    LocalizedName: 'Nauru',
  },
  {
    Name: 'Nepal',
    Alpha2: 'NP',
    Alpha3: 'NPL',
    Numeric: 524,
    Iso3166_2: 'ISO 3166-2:NP',
    LocalizedName: 'Nepal',
  },
  {
    Name: 'Netherlands (the)',
    Alpha2: 'NL',
    Alpha3: 'NLD',
    Numeric: 528,
    Iso3166_2: 'ISO 3166-2:NL',
    LocalizedName: 'Netherlands',
  },
  {
    Name: 'New Caledonia',
    Alpha2: 'NC',
    Alpha3: 'NCL',
    Numeric: 540,
    Iso3166_2: 'ISO 3166-2:NC',
    LocalizedName: 'New Caledonia',
  },
  {
    Name: 'New Zealand',
    Alpha2: 'NZ',
    Alpha3: 'NZL',
    Numeric: 554,
    Iso3166_2: 'ISO 3166-2:NZ',
    LocalizedName: 'New Zealand',
  },
  {
    Name: 'Nicaragua',
    Alpha2: 'NI',
    Alpha3: 'NIC',
    Numeric: 558,
    Iso3166_2: 'ISO 3166-2:NI',
    LocalizedName: 'Nicaragua',
  },
  {
    Name: 'Niger (the)',
    Alpha2: 'NE',
    Alpha3: 'NER',
    Numeric: 562,
    Iso3166_2: 'ISO 3166-2:NE',
    LocalizedName: 'Niger',
  },
  {
    Name: 'Nigeria',
    Alpha2: 'NG',
    Alpha3: 'NGA',
    Numeric: 566,
    Iso3166_2: 'ISO 3166-2:NG',
    LocalizedName: 'Nigeria',
  },
  {
    Name: 'Niue',
    Alpha2: 'NU',
    Alpha3: 'NIU',
    Numeric: 570,
    Iso3166_2: 'ISO 3166-2:NU',
    LocalizedName: 'Niue',
  },
  {
    Name: 'Norfolk Island',
    Alpha2: 'NF',
    Alpha3: 'NFK',
    Numeric: 574,
    Iso3166_2: 'ISO 3166-2:NF',
    LocalizedName: 'Norfolk Island',
  },
  {
    Name: 'Northern Mariana Islands (the)',
    Alpha2: 'MP',
    Alpha3: 'MNP',
    Numeric: 580,
    Iso3166_2: 'ISO 3166-2:MP',
    LocalizedName: 'Northern Mariana Islands',
  },
  {
    Name: 'Norway',
    Alpha2: 'NO',
    Alpha3: 'NOR',
    Numeric: 578,
    Iso3166_2: 'ISO 3166-2:NO',
    LocalizedName: 'Norway',
  },
  {
    Name: 'Oman',
    Alpha2: 'OM',
    Alpha3: 'OMN',
    Numeric: 512,
    Iso3166_2: 'ISO 3166-2:OM',
    LocalizedName: 'Oman',
  },
  {
    Name: 'Pakistan',
    Alpha2: 'PK',
    Alpha3: 'PAK',
    Numeric: 586,
    Iso3166_2: 'ISO 3166-2:PK',
    LocalizedName: 'Pakistan',
  },
  {
    Name: 'Palau',
    Alpha2: 'PW',
    Alpha3: 'PLW',
    Numeric: 585,
    Iso3166_2: 'ISO 3166-2:PW',
    LocalizedName: 'Palau',
  },
  {
    Name: 'Palestine, State of',
    Alpha2: 'PS',
    Alpha3: 'PSE',
    Numeric: 275,
    Iso3166_2: 'ISO 3166-2:PS',
    LocalizedName: 'Palestinian Territories',
  },
  {
    Name: 'Panama',
    Alpha2: 'PA',
    Alpha3: 'PAN',
    Numeric: 591,
    Iso3166_2: 'ISO 3166-2:PA',
    LocalizedName: 'Panama',
  },
  {
    Name: 'Papua New Guinea',
    Alpha2: 'PG',
    Alpha3: 'PNG',
    Numeric: 598,
    Iso3166_2: 'ISO 3166-2:PG',
    LocalizedName: 'Papua New Guinea',
  },
  {
    Name: 'Paraguay',
    Alpha2: 'PY',
    Alpha3: 'PRY',
    Numeric: 600,
    Iso3166_2: 'ISO 3166-2:PY',
    LocalizedName: 'Paraguay',
  },
  {
    Name: 'Peru',
    Alpha2: 'PE',
    Alpha3: 'PER',
    Numeric: 604,
    Iso3166_2: 'ISO 3166-2:PE',
    LocalizedName: 'Peru',
  },
  {
    Name: 'Philippines (the)',
    Alpha2: 'PH',
    Alpha3: 'PHL',
    Numeric: 608,
    Iso3166_2: 'ISO 3166-2:PH',
    LocalizedName: 'Philippines',
  },
  {
    Name: 'Pitcairn',
    Alpha2: 'PN',
    Alpha3: 'PCN',
    Numeric: 612,
    Iso3166_2: 'ISO 3166-2:PN',
    LocalizedName: 'Pitcairn Islands',
  },
  {
    Name: 'Poland',
    Alpha2: 'PL',
    Alpha3: 'POL',
    Numeric: 616,
    Iso3166_2: 'ISO 3166-2:PL',
    LocalizedName: 'Poland',
  },
  {
    Name: 'Portugal',
    Alpha2: 'PT',
    Alpha3: 'PRT',
    Numeric: 620,
    Iso3166_2: 'ISO 3166-2:PT',
    LocalizedName: 'Portugal',
  },
  {
    Name: 'Puerto Rico',
    Alpha2: 'PR',
    Alpha3: 'PRI',
    Numeric: 630,
    Iso3166_2: 'ISO 3166-2:PR',
    LocalizedName: 'Puerto Rico',
  },
  {
    Name: 'Qatar',
    Alpha2: 'QA',
    Alpha3: 'QAT',
    Numeric: 634,
    Iso3166_2: 'ISO 3166-2:QA',
    LocalizedName: 'Qatar',
  },
  {
    Name: 'Réunion',
    Alpha2: 'RE',
    Alpha3: 'REU',
    Numeric: 638,
    Iso3166_2: 'ISO 3166-2:RE',
    LocalizedName: 'Réunion',
  },
  {
    Name: 'Romania',
    Alpha2: 'RO',
    Alpha3: 'ROU',
    Numeric: 642,
    Iso3166_2: 'ISO 3166-2:RO',
    LocalizedName: 'Romania',
  },
  {
    Name: 'Russian Federation (the)',
    Alpha2: 'RU',
    Alpha3: 'RUS',
    Numeric: 643,
    Iso3166_2: 'ISO 3166-2:RU',
    LocalizedName: 'Russia',
  },
  {
    Name: 'Rwanda',
    Alpha2: 'RW',
    Alpha3: 'RWA',
    Numeric: 646,
    Iso3166_2: 'ISO 3166-2:RW',
    LocalizedName: 'Rwanda',
  },
  {
    Name: 'Saint Barthélemy',
    Alpha2: 'BL',
    Alpha3: 'BLM',
    Numeric: 652,
    Iso3166_2: 'ISO 3166-2:BL',
    LocalizedName: 'St. Barthélemy',
  },
  {
    Name: 'Saint Helena, Ascension and Tristan da Cunha',
    Alpha2: 'SH',
    Alpha3: 'SHN',
    Numeric: 654,
    Iso3166_2: 'ISO 3166-2:SH',
    LocalizedName: 'St. Helena',
  },
  {
    Name: 'Saint Kitts and Nevis',
    Alpha2: 'KN',
    Alpha3: 'KNA',
    Numeric: 659,
    Iso3166_2: 'ISO 3166-2:KN',
    LocalizedName: 'St. Kitts & Nevis',
  },
  {
    Name: 'Saint Lucia',
    Alpha2: 'LC',
    Alpha3: 'LCA',
    Numeric: 662,
    Iso3166_2: 'ISO 3166-2:LC',
    LocalizedName: 'St. Lucia',
  },
  {
    Name: 'Saint Martin (French part)',
    Alpha2: 'MF',
    Alpha3: 'MAF',
    Numeric: 663,
    Iso3166_2: 'ISO 3166-2:MF',
    LocalizedName: 'St. Martin',
  },
  {
    Name: 'Saint Pierre and Miquelon',
    Alpha2: 'PM',
    Alpha3: 'SPM',
    Numeric: 666,
    Iso3166_2: 'ISO 3166-2:PM',
    LocalizedName: 'St. Pierre & Miquelon',
  },
  {
    Name: 'Saint Vincent and the Grenadines',
    Alpha2: 'VC',
    Alpha3: 'VCT',
    Numeric: 670,
    Iso3166_2: 'ISO 3166-2:VC',
    LocalizedName: 'St. Vincent & Grenadines',
  },
  {
    Name: 'Samoa',
    Alpha2: 'WS',
    Alpha3: 'WSM',
    Numeric: 882,
    Iso3166_2: 'ISO 3166-2:WS',
    LocalizedName: 'Samoa',
  },
  {
    Name: 'San Marino',
    Alpha2: 'SM',
    Alpha3: 'SMR',
    Numeric: 674,
    Iso3166_2: 'ISO 3166-2:SM',
    LocalizedName: 'San Marino',
  },
  {
    Name: 'Sao Tome and Principe',
    Alpha2: 'ST',
    Alpha3: 'STP',
    Numeric: 678,
    Iso3166_2: 'ISO 3166-2:ST',
    LocalizedName: 'São Tomé & Príncipe',
  },
  {
    Name: 'Saudi Arabia',
    Alpha2: 'SA',
    Alpha3: 'SAU',
    Numeric: 682,
    Iso3166_2: 'ISO 3166-2:SA',
    LocalizedName: 'Saudi Arabia',
  },
  {
    Name: 'Senegal',
    Alpha2: 'SN',
    Alpha3: 'SEN',
    Numeric: 686,
    Iso3166_2: 'ISO 3166-2:SN',
    LocalizedName: 'Senegal',
  },
  {
    Name: 'Serbia',
    Alpha2: 'RS',
    Alpha3: 'SRB',
    Numeric: 688,
    Iso3166_2: 'ISO 3166-2:RS',
    LocalizedName: 'Serbia',
  },
  {
    Name: 'Seychelles',
    Alpha2: 'SC',
    Alpha3: 'SYC',
    Numeric: 690,
    Iso3166_2: 'ISO 3166-2:SC',
    LocalizedName: 'Seychelles',
  },
  {
    Name: 'Sierra Leone',
    Alpha2: 'SL',
    Alpha3: 'SLE',
    Numeric: 694,
    Iso3166_2: 'ISO 3166-2:SL',
    LocalizedName: 'Sierra Leone',
  },
  {
    Name: 'Singapore',
    Alpha2: 'SG',
    Alpha3: 'SGP',
    Numeric: 702,
    Iso3166_2: 'ISO 3166-2:SG',
    LocalizedName: 'Singapore',
  },
  {
    Name: 'Sint Maarten (Dutch part)',
    Alpha2: 'SX',
    Alpha3: 'SXM',
    Numeric: 534,
    Iso3166_2: 'ISO 3166-2:SX',
    LocalizedName: 'Sint Maarten',
  },
  {
    Name: 'Slovakia',
    Alpha2: 'SK',
    Alpha3: 'SVK',
    Numeric: 703,
    Iso3166_2: 'ISO 3166-2:SK',
    LocalizedName: 'Slovakia',
  },
  {
    Name: 'Slovenia',
    Alpha2: 'SI',
    Alpha3: 'SVN',
    Numeric: 705,
    Iso3166_2: 'ISO 3166-2:SI',
    LocalizedName: 'Slovenia',
  },
  {
    Name: 'Solomon Islands',
    Alpha2: 'SB',
    Alpha3: 'SLB',
    Numeric: 90,
    Iso3166_2: 'ISO 3166-2:SB',
    LocalizedName: 'Solomon Islands',
  },
  {
    Name: 'Somalia',
    Alpha2: 'SO',
    Alpha3: 'SOM',
    Numeric: 706,
    Iso3166_2: 'ISO 3166-2:SO',
    LocalizedName: 'Somalia',
  },
  {
    Name: 'South Africa',
    Alpha2: 'ZA',
    Alpha3: 'ZAF',
    Numeric: 710,
    Iso3166_2: 'ISO 3166-2:ZA',
    LocalizedName: 'South Africa',
  },
  {
    Name: 'South Georgia and the South Sandwich Islands',
    Alpha2: 'GS',
    Alpha3: 'SGS',
    Numeric: 239,
    Iso3166_2: 'ISO 3166-2:GS',
    LocalizedName: 'South Georgia & South Sandwich Islands',
  },
  {
    Name: 'South Sudan',
    Alpha2: 'SS',
    Alpha3: 'SSD',
    Numeric: 728,
    Iso3166_2: 'ISO 3166-2:SS',
    LocalizedName: 'South Sudan',
  },
  {
    Name: 'Spain',
    Alpha2: 'ES',
    Alpha3: 'ESP',
    Numeric: 724,
    Iso3166_2: 'ISO 3166-2:ES',
    LocalizedName: 'Spain',
  },
  {
    Name: 'Sri Lanka',
    Alpha2: 'LK',
    Alpha3: 'LKA',
    Numeric: 144,
    Iso3166_2: 'ISO 3166-2:LK',
    LocalizedName: 'Sri Lanka',
  },
  {
    Name: 'Sudan (the)',
    Alpha2: 'SD',
    Alpha3: 'SDN',
    Numeric: 729,
    Iso3166_2: 'ISO 3166-2:SD',
    LocalizedName: 'Sudan',
  },
  {
    Name: 'Suriname',
    Alpha2: 'SR',
    Alpha3: 'SUR',
    Numeric: 740,
    Iso3166_2: 'ISO 3166-2:SR',
    LocalizedName: 'Suriname',
  },
  {
    Name: 'Svalbard and Jan Mayen',
    Alpha2: 'SJ',
    Alpha3: 'SJM',
    Numeric: 744,
    Iso3166_2: 'ISO 3166-2:SJ',
    LocalizedName: 'Svalbard & Jan Mayen',
  },
  {
    Name: 'Eswatini',
    Alpha2: 'SZ',
    Alpha3: 'SWZ',
    Numeric: 748,
    Iso3166_2: 'ISO 3166-2:SZ',
    LocalizedName: 'Eswatini',
  },
  {
    Name: 'Sweden',
    Alpha2: 'SE',
    Alpha3: 'SWE',
    Numeric: 752,
    Iso3166_2: 'ISO 3166-2:SE',
    LocalizedName: 'Sweden',
  },
  {
    Name: 'Switzerland',
    Alpha2: 'CH',
    Alpha3: 'CHE',
    Numeric: 756,
    Iso3166_2: 'ISO 3166-2:CH',
    LocalizedName: 'Switzerland',
  },
  {
    Name: 'Syrian Arab Republic (the)',
    Alpha2: 'SY',
    Alpha3: 'SYR',
    Numeric: 760,
    Iso3166_2: 'ISO 3166-2:SY',
    LocalizedName: 'Syria',
  },
  {
    Name: 'Taiwan (Province of China)',
    Alpha2: 'TW',
    Alpha3: 'TWN',
    Numeric: 158,
    Iso3166_2: 'ISO 3166-2:TW',
    LocalizedName: 'Taiwan',
  },
  {
    Name: 'Tajikistan',
    Alpha2: 'TJ',
    Alpha3: 'TJK',
    Numeric: 762,
    Iso3166_2: 'ISO 3166-2:TJ',
    LocalizedName: 'Tajikistan',
  },
  {
    Name: 'Tanzania, the United Republic of',
    Alpha2: 'TZ',
    Alpha3: 'TZA',
    Numeric: 834,
    Iso3166_2: 'ISO 3166-2:TZ',
    LocalizedName: 'Tanzania',
  },
  {
    Name: 'Thailand',
    Alpha2: 'TH',
    Alpha3: 'THA',
    Numeric: 764,
    Iso3166_2: 'ISO 3166-2:TH',
    LocalizedName: 'Thailand',
  },
  {
    Name: 'Timor-Leste',
    Alpha2: 'TL',
    Alpha3: 'TLS',
    Numeric: 626,
    Iso3166_2: 'ISO 3166-2:TL',
    LocalizedName: 'Timor-Leste',
  },
  {
    Name: 'Togo',
    Alpha2: 'TG',
    Alpha3: 'TGO',
    Numeric: 768,
    Iso3166_2: 'ISO 3166-2:TG',
    LocalizedName: 'Togo',
  },
  {
    Name: 'Tokelau',
    Alpha2: 'TK',
    Alpha3: 'TKL',
    Numeric: 772,
    Iso3166_2: 'ISO 3166-2:TK',
    LocalizedName: 'Tokelau',
  },
  {
    Name: 'Tonga',
    Alpha2: 'TO',
    Alpha3: 'TON',
    Numeric: 776,
    Iso3166_2: 'ISO 3166-2:TO',
    LocalizedName: 'Tonga',
  },
  {
    Name: 'Trinidad and Tobago',
    Alpha2: 'TT',
    Alpha3: 'TTO',
    Numeric: 780,
    Iso3166_2: 'ISO 3166-2:TT',
    LocalizedName: 'Trinidad & Tobago',
  },
  {
    Name: 'Tunisia',
    Alpha2: 'TN',
    Alpha3: 'TUN',
    Numeric: 788,
    Iso3166_2: 'ISO 3166-2:TN',
    LocalizedName: 'Tunisia',
  },
  {
    Name: 'Turkey',
    Alpha2: 'TR',
    Alpha3: 'TUR',
    Numeric: 792,
    Iso3166_2: 'ISO 3166-2:TR',
    LocalizedName: 'Turkey',
  },
  {
    Name: 'Turkmenistan',
    Alpha2: 'TM',
    Alpha3: 'TKM',
    Numeric: 795,
    Iso3166_2: 'ISO 3166-2:TM',
    LocalizedName: 'Turkmenistan',
  },
  {
    Name: 'Turks and Caicos Islands (the)',
    Alpha2: 'TC',
    Alpha3: 'TCA',
    Numeric: 796,
    Iso3166_2: 'ISO 3166-2:TC',
    LocalizedName: 'Turks & Caicos Islands',
  },
  {
    Name: 'Tuvalu',
    Alpha2: 'TV',
    Alpha3: 'TUV',
    Numeric: 798,
    Iso3166_2: 'ISO 3166-2:TV',
    LocalizedName: 'Tuvalu',
  },
  {
    Name: 'Uganda',
    Alpha2: 'UG',
    Alpha3: 'UGA',
    Numeric: 800,
    Iso3166_2: 'ISO 3166-2:UG',
    LocalizedName: 'Uganda',
  },
  {
    Name: 'Ukraine',
    Alpha2: 'UA',
    Alpha3: 'UKR',
    Numeric: 804,
    Iso3166_2: 'ISO 3166-2:UA',
    LocalizedName: 'Ukraine',
  },
  {
    Name: 'United Arab Emirates (the)',
    Alpha2: 'AE',
    Alpha3: 'ARE',
    Numeric: 784,
    Iso3166_2: 'ISO 3166-2:AE',
    LocalizedName: 'United Arab Emirates',
  },
  {
    Name: 'United Kingdom of Great Britain and Northern Ireland (the)',
    Alpha2: 'GB',
    Alpha3: 'GBR',
    Numeric: 826,
    Iso3166_2: 'ISO 3166-2:GB',
    LocalizedName: 'United Kingdom',
  },
  {
    Name: 'United States of America (the)',
    Alpha2: 'US',
    Alpha3: 'USA',
    Numeric: 840,
    Iso3166_2: 'ISO 3166-2:US',
    LocalizedName: 'United States',
  },
  {
    Name: 'United States Minor Outlying Islands (the)',
    Alpha2: 'UM',
    Alpha3: 'UMI',
    Numeric: 581,
    Iso3166_2: 'ISO 3166-2:UM',
    LocalizedName: 'U.S. Outlying Islands',
  },
  {
    Name: 'Uruguay',
    Alpha2: 'UY',
    Alpha3: 'URY',
    Numeric: 858,
    Iso3166_2: 'ISO 3166-2:UY',
    LocalizedName: 'Uruguay',
  },
  {
    Name: 'Uzbekistan',
    Alpha2: 'UZ',
    Alpha3: 'UZB',
    Numeric: 860,
    Iso3166_2: 'ISO 3166-2:UZ',
    LocalizedName: 'Uzbekistan',
  },
  {
    Name: 'Vanuatu',
    Alpha2: 'VU',
    Alpha3: 'VUT',
    Numeric: 548,
    Iso3166_2: 'ISO 3166-2:VU',
    LocalizedName: 'Vanuatu',
  },
  {
    Name: 'Venezuela (Bolivarian Republic of)',
    Alpha2: 'VE',
    Alpha3: 'VEN',
    Numeric: 862,
    Iso3166_2: 'ISO 3166-2:VE',
    LocalizedName: 'Venezuela',
  },
  {
    Name: 'Viet Nam',
    Alpha2: 'VN',
    Alpha3: 'VNM',
    Numeric: 704,
    Iso3166_2: 'ISO 3166-2:VN',
    LocalizedName: 'Vietnam',
  },
  {
    Name: 'Virgin Islands (British)',
    Alpha2: 'VG',
    Alpha3: 'VGB',
    Numeric: 92,
    Iso3166_2: 'ISO 3166-2:VG',
    LocalizedName: 'British Virgin Islands',
  },
  {
    Name: 'Virgin Islands (U.S.)',
    Alpha2: 'VI',
    Alpha3: 'VIR',
    Numeric: 850,
    Iso3166_2: 'ISO 3166-2:VI',
    LocalizedName: 'U.S. Virgin Islands',
  },
  {
    Name: 'Wallis and Futuna',
    Alpha2: 'WF',
    Alpha3: 'WLF',
    Numeric: 876,
    Iso3166_2: 'ISO 3166-2:WF',
    LocalizedName: 'Wallis & Futuna',
  },
  {
    Name: 'Western Sahara',
    Alpha2: 'EH',
    Alpha3: 'ESH',
    Numeric: 732,
    Iso3166_2: 'ISO 3166-2:EH',
    LocalizedName: 'Western Sahara',
  },
  {
    Name: 'Yemen',
    Alpha2: 'YE',
    Alpha3: 'YEM',
    Numeric: 887,
    Iso3166_2: 'ISO 3166-2:YE',
    LocalizedName: 'Yemen',
  },
  {
    Name: 'Zambia',
    Alpha2: 'ZM',
    Alpha3: 'ZMB',
    Numeric: 894,
    Iso3166_2: 'ISO 3166-2:ZM',
    LocalizedName: 'Zambia',
  },
  {
    Name: 'Zimbabwe',
    Alpha2: 'ZW',
    Alpha3: 'ZWE',
    Numeric: 716,
    Iso3166_2: 'ISO 3166-2:ZW',
    LocalizedName: 'Zimbabwe',
  },
]
